export default __webpack_public_path__ + "static/media/pillarofinfernalflame2.1f3029f0.png";